import React, { useState, useEffect } from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const PurchaseValueInput = ({ 
  value, 
  onChange, 
  cashbackPercentage, 
  rewardCap, 
  error 
}) => {
  const [calculatedCashback, setCalculatedCashback] = useState(0);
  const [cappedCashback, setCappedCashback] = useState(0);

  useEffect(() => {
    if (value && cashbackPercentage) {
      const numValue = parseFloat(value) || 0;
      const calculated = (numValue * cashbackPercentage) / 100;
      const capped = Math.min(calculated, rewardCap);
      
      setCalculatedCashback(calculated);
      setCappedCashback(capped);
    } else {
      setCalculatedCashback(0);
      setCappedCashback(0);
    }
  }, [value, cashbackPercentage, rewardCap]);

  const handleChange = (e) => {
    const inputValue = e?.target?.value?.replace(/[^0-9.]/g, '');
    onChange(inputValue);
  };

  return (
    <div className="space-y-4">
      <Input
        label="Purchase Amount"
        type="text"
        placeholder="0.00"
        value={value}
        onChange={handleChange}
        error={error}
        required
        description="Enter the total purchase amount from your receipt"
      />
      {value && cashbackPercentage > 0 && (
        <div className="bg-gradient-to-br from-success/10 via-warning/10 to-primary/10 rounded-xl p-4 md:p-6 border border-success/20">
          <div className="flex items-center gap-2 mb-3">
            <Icon name="Calculator" size={20} color="var(--color-success)" />
            <h4 className="text-sm md:text-base font-semibold text-foreground">
              Cashback Calculation
            </h4>
          </div>
          
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-xs md:text-sm text-muted-foreground">
                Purchase Amount:
              </span>
              <span className="text-sm md:text-base font-medium text-foreground">
                ${parseFloat(value)?.toFixed(2)}
              </span>
            </div>
            
            <div className="flex items-center justify-between">
              <span className="text-xs md:text-sm text-muted-foreground">
                Cashback Rate:
              </span>
              <span className="text-sm md:text-base font-medium text-primary">
                {cashbackPercentage}%
              </span>
            </div>
            
            <div className="h-px bg-border"></div>
            
            <div className="flex items-center justify-between">
              <span className="text-xs md:text-sm text-muted-foreground">
                Calculated Cashback:
              </span>
              <span className="text-sm md:text-base font-medium text-foreground">
                ${calculatedCashback?.toFixed(2)}
              </span>
            </div>
            
            {calculatedCashback > rewardCap && (
              <div className="flex items-start gap-2 p-3 bg-warning/10 rounded-lg border border-warning/20">
                <Icon name="AlertCircle" size={16} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
                <p className="text-xs text-warning">
                  Reward capped at ${rewardCap?.toFixed(2)} per transaction
                </p>
              </div>
            )}
            
            <div className="flex items-center justify-between pt-2">
              <span className="text-sm md:text-base font-semibold text-foreground">
                You'll Earn:
              </span>
              <span className="text-lg md:text-xl font-bold bg-gradient-to-r from-success to-warning bg-clip-text text-transparent">
                ${cappedCashback?.toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchaseValueInput;